import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';
import { ShoppingCart } from 'lucide-react';
import { formatCurrency } from '../../utils/formatCurrency';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleAddToCart = (e) => {
    e.preventDefault();

    // Check if user is logged in
    if (!currentUser) {
      toast.error('Vui lòng đăng nhập để thêm sản phẩm vào giỏ hàng');
      navigate('/login');
      return;
    }

    addToCart(product);
    toast.success('Đã thêm sản phẩm vào giỏ hàng');
  };

  // Get the main image (first image from images array, or fallback to imageUrl)
  const mainImage = (product.images && product.images.length > 0)
    ? product.images[0]
    : (product.imageUrl || 'https://via.placeholder.com/400');

  return (
    <Link to={`/products/${product.id}`} className="group">
      <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition duration-300">
        {/* Image */}
        <div className="relative overflow-hidden aspect-square">
          <img
            src={mainImage}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-110 transition duration-300"
          />
          {product.discount && (
            <div className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-md text-sm font-semibold">
              -{product.discount}%
            </div>
          )}
          {/* Show image count badge if multiple images */}
          {product.images && product.images.length > 1 && (
            <div className="absolute bottom-2 right-2 bg-black/60 text-white px-2 py-1 rounded text-xs">
              📷 {product.images.length}
            </div>
          )}
        </div>

        {/* Content */}
        <div className="p-4">
          <h3 className="font-semibold text-lg mb-2 line-clamp-2 group-hover:text-primary-600 transition">
            {product.name}
          </h3>

          <div className="flex items-center justify-between mb-3">
            <div>
              <p className="text-primary-600 font-bold text-xl">
                {formatCurrency(product.price)}
              </p>
              {product.originalPrice && (
                <p className="text-gray-400 text-sm line-through">
                  {formatCurrency(product.originalPrice)}
                </p>
              )}
            </div>
          </div>

          {/* Category Badge */}
          <div className="mb-3">
            <span className="inline-block bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded">
              {product.category}
            </span>
          </div>

          {/* Add to Cart Button */}
          <button
            onClick={handleAddToCart}
            className="w-full bg-primary-600 text-white py-2 rounded-lg hover:bg-primary-700 transition flex items-center justify-center gap-2"
          >
            <ShoppingCart className="w-4 h-4" />
            Thêm Vào Giỏ
          </button>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
